// extracted by mini-css-extract-plugin
export default {"container":"container-2cAMk","title":"title-3PDVc","subTitle":"subTitle-2PJmp","close":"close-1gIU-","icon":"icon-3Gntg"};